import type { IndividualProfile, CompanyProfile } from '@/services/profileService'

// onboarding มีเฉพาะบัญชีบริษัท — บุคคลทั่วไปไม่ต้องกรอกข้อมูลเพิ่ม
// ตัดสินจากข้อมูลที่บันทึกจริงใน DB (ไม่ใช้ localStorage) กรอกครบครั้งเดียวก็ไม่ขึ้นอีก ไม่ว่าจะ login จากเครื่องไหน
export function needsOnboarding(profile: IndividualProfile | CompanyProfile): boolean {
  if ('first_name' in profile) return false
  return !profile.company_name?.trim() || !profile.industry?.trim() || !profile.company_size
    || !profile.location?.trim() || !profile.tax_id?.trim()
}
